import React from 'react';
import {Container} from 'react-bootstrap';

const NotFound = () => {
  return (
    <Container className='d-flex justify-content-center mt-5'>
      <h1>404 Page Not Found ...</h1>
    </Container>
  );
};

export default NotFound;
